import change from "./ChangePass.module.css";
import { useState, useEffect, useRef, useContext } from "react";
import AppContext from "../../context";
import Backdrop from "../Backdrop/Backdrop";
import { AlertEntity } from "../Alert/AlertEntity";
import { AuthService } from "../../services/auth";
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";

export default function ChangePass(props: { showChangePass: boolean; setShowChangePass: (val: boolean) => void; authService: AuthService; }) {
  const { showChangePass, setShowChangePass, authService } = props;
  const context = useContext(AppContext);
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const userRef = useRef<HTMLInputElement | null>(null);

  const [currPwd, setCurrPwd] = useState("");
  const [validCurrPwd, setValidCurrPwd] = useState(false);
  const [currPwdFocus, setCurrPwdFocus] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);
  const [validPwdCheckUppercase, setValidPwdCheckUppercase] = useState(false);
  const [validPwdCheckLowercase, setValidPwdCheckLowercase] = useState(false);
  const [validPwdCheckNumber, setValidPwdCheckNumber] = useState(false);
  const [validPwdCheckSpecial, setValidPwdCheckSpecial] = useState(false);
  const [validPwdCheckLength, setValidPwdCheckLength] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [match, setMatch] = useState("");
  const [validMatch, setValidMatch] = useState(false);

  useEffect(() => {
    if (userRef != null && userRef.current != null) {
      userRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%*/]).{8,24}$/;
    const PWD_REGEX_UPPERCASE = /^(?=.*[A-Z])/;
    const PWD_REGEX_LOWERCASE = /^(?=.*[a-z])/;
    const PWD_REGEX_NUMBER = /^(?=.*[0-9])/;
    const PWD_REGEX_SPECIAL = /^(?=.*[!@#$%*/])/;
    const PWD_REGEX_LENGTH = /^.{8,24}/;

    setValidPwdCheckUppercase(PWD_REGEX_UPPERCASE.test(pwd));
    setValidPwdCheckLowercase(PWD_REGEX_LOWERCASE.test(pwd));
    setValidPwdCheckNumber(PWD_REGEX_NUMBER.test(pwd));
    setValidPwdCheckSpecial(PWD_REGEX_SPECIAL.test(pwd));
    setValidPwdCheckLength(PWD_REGEX_LENGTH.test(pwd));
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === match);
  }, [pwd, match]);

  async function updatePassword() {
    if (!validMatch || !validPwd) {
      return contextShowAlertFunc(new AlertEntity({ message: "New Password Must Match & Valid", level: 3 }))
    }
    contextShowLoadingFunc(true);
    try {
      let resp = await authService.changePass(currPwd, pwd);
      setPwd("");
      setCurrPwd("");
      setMatch("");
      contextShowLoadingFunc(false);
      setShowChangePass(false);
      return contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }))
    } catch (error: any) {
      contextShowLoadingFunc(false);
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }
  async function handleCurrPassword(e: { target: { value: any }; }) {
    let password = e.target.value;
    setCurrPwd(password);
    setValidCurrPwd(true);
  }
  return (
    <>
      {showChangePass && <Backdrop close={() => setShowChangePass(false)} />}
      {showChangePass && (
        <div className={change.container}>
          <div className={change.background}>
            <div className={change.formPass}>
              <h2>Change Password</h2>
              <label>Current Password</label>
              <input
                ref={userRef}
                type={"password"}
                required
                style={{backgroundColor: "white"}}
                onChange={handleCurrPassword}
                value={currPwd}
                onFocus={() => setCurrPwdFocus(true)}
                onBlur={() => setCurrPwdFocus(false)}
              />
              {currPwd == "" &&
                <div className={change.warn} >
                  <p style={{ fontSize: "12px" }}>
                    <span>Need Current Password:</span> Please Enter Current
                    Password.
                  </p>
                </div>
              }
              <div
                className={
                  currPwd && !validCurrPwd
                    ? `${change.warn}`
                    : `${change.warnOff}`
                }
              >
                <p>
                  <span>Wrong Password:</span> Enter the correct password.
                </p>
              </div>

              <label>New Password</label>
              <input
                ref={userRef}
                type={"password"}
                required
                onChange={(e) => setPwd(e.target.value)}
                value={pwd}
                style={{backgroundColor: "white"}}
                onFocus={() => setPwdFocus(true)}
                onBlur={() => setPwdFocus(false)}
              />

              <label>Confirm New Password</label>
              <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                <input
                  ref={userRef} type={"password"} style={{ flex: "98%", backgroundColor: "white" }}
                  required onChange={(e) => setMatch(e.target.value)}
                  value={match}
                />
                <div style={{ flex: "2%" }}>
                  {validMatch == true && match != "" ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                </div>
              </div>
              <div style={{ textAlign: "start", fontSize: "12px" }}>
                <div style={{ fontWeight: "600", fontSize: "14px" }}>New Password Must :</div>
                <div>
                  {validPwdCheckUppercase == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                  Use Uppercase
                </div>
                <div>
                  {validPwdCheckLowercase == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                  Use Lowercase
                </div>
                <div>
                  {validPwdCheckNumber == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                  Use Number
                </div>
                <div>
                  {validPwdCheckSpecial == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                  Use Special Character "!@#$%*/"
                </div>
                <div>
                  {validPwdCheckLength == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                  More Than 8 Character
                </div>
              </div>

              <div className={change.buttons}>
                <button
                  className="tertiaryButton"
                  onClick={() => setShowChangePass(false)}
                >
                  Cancel
                </button>
                <button className="primaryButton" onClick={updatePassword}>
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
